import React from 'react';

const YoungPlant = ({ height = 32, width = 32, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <title>plant ground</title>
    <g fill={color}>
      <path d="M31,29h-9.10059C21.43457,26.7207,19.41504,25,17,25v-4c3.31372,0,6-2.68628,6-6v-4h-1 c-2.08813,0-3.92535,1.06781-5,2.68604V2.12939c0-0.55225-0.44727-1-1-1s-1,0.44775-1,1v7.55664C13.92535,8.06781,12.08813,7,10,7H9 v4c0,3.31372,2.68628,6,6,6v8.42432c-0.83911,0.36652-1.57001,0.95294-2.09961,1.71729C12.61035,27.04834,12.30664,27,12,27 c-1.30371,0-2.41602,0.83594-2.8291,2H1c-0.55273,0-1,0.44775-1,1s0.44727,1,1,1h30c0.55273,0,1-0.44775,1-1S31.55273,29,31,29z" fill={color}/>
    </g>
  </svg>
);

export default YoungPlant;
